import { render, staticRenderFns } from "./index_chaishu.vue?vue&type=template&id=67677290&scoped=true"
import script from "./index_chaishu.vue?vue&type=script&lang=js"
export * from "./index_chaishu.vue?vue&type=script&lang=js"
import style0 from "./index_chaishu.vue?vue&type=style&index=0&id=67677290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67677290",
  null
  
)

/* custom blocks */
import block0 from "./index_chaishu.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports